import React from "react";
import { animated } from "react-spring/renderprops";
import "./App.css";
import "../../assets/scss/styles.scss";
import Header from "../commons/header";
import { Helmet } from "react-helmet";

function App(props) {
  return (
    <animated.div style={props.style}>
      <div className="fullwidth-white-bg">
        <Header className="sticky" />
        {/* <div className="fullwidth-white-bg" /> */}
        {props.children}
      </div>
    </animated.div>
  );
}

export default App;
